import React from 'react';
import { Typography } from 'fronton-react';
import { selectWindowType, WindowTypes } from 'store/pageStore';
import { checkScreenType, GAPromoClick } from 'utils';
import { useSelector } from 'react-redux';
import { ServiceType } from '../../other-services-db';
import { serviceStyles, serviceTypographyStyles } from './styles';

export const Service = ({ name, img, src, index = 0 }: ServiceType) => {
	const screenType = useSelector(selectWindowType);
	const isMobile = checkScreenType(screenType, WindowTypes.mobile);
	const handleClickOtherService = () =>
		GAPromoClick({
			elementBlock: 'landingChernovoyRemont',
			promotions: [
				{ name: 'landingChernovoyRemont_bottom', creative: name, position: `${index + 1}` },
			],
		});
	return (
		<a href={src} className={serviceStyles} onClick={handleClickOtherService}>
			<img src={img} alt="" />
			<Typography
				className={serviceTypographyStyles}
				variant={isMobile ? 'm' : 'l'}
				size="subtitle"
			>
				{name}
			</Typography>
		</a>
	);
};
